import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from '../../../guards/auth/auth.guard';
import { ChargingStationsTableComponent } from './charging-stations-table/charging-stations-table.component';
import { RouterModule } from '@angular/router';
import { ChargingStationsComponent } from './charging-stations.component';
import { CreateChargingStationDialogComponent } from '@components/dialog/create-charging-station-dialog/create-charging-station-dialog.component';
import { DetailsChargingStationDialogComponent } from '@components/dialog/details-charging-station-dialog/details-charging-station-dialog.component';
import { DeleteChargingStationDialogComponent } from '@components/dialog/delete-charging-station-dialog/delete-charging-station-dialog.component';
import { UpdateChargingStationDialogComponent } from '@components/dialog/update-charging-station-dialog/update-charging-station-dialog.component';
import { RoleGuard } from '@guards/role/role.guard';
import { GroupsComponent } from '../../manage/groups/groups.component';
import { DeleteGroupDialogComponent } from '@components/dialog/delete-group-dialog/delete-group-dialog.component';
import { EditGroupDialogComponent } from '@components/dialog/edit-group-dialog/edit-group-dialog.component';
import { RestartChargingStationDialogContentComponent } from '../../dialog/restart-charging-station-dialog-content/restart-charging-station-dialog-content.component';
import { RestartChargingStationDialogComponent } from '../../dialog/restart-charging-station-dialog-content/restart-charging-station-dialog-component';
import { ManufacturerTableComponent } from '@components/operator/manufacturer/manufacturer.component';
import { DiagnosticChargingStationDialogComponent } from '../../dialog/diagnostic-charging-station-dialog/diagnostics-charging-station-dialog-component';
import { DiagnosticChargingStationDialogContentComponent } from '../../dialog/diagnostic-charging-station-dialog/diagnostic-charging-station-dialog-content/diagnostics-charging-station-dialog-content.component';
import { StatusNotificationsTableComponent } from '@components/operator/statusnotifications/statusnotifications.component';
import { CreateChargingStationAssistentDialogComponent } from '../../dialog/create-charging-station-assistent-dialog/create-charging-station-assistent-dialog.component';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(
      [
        {
          path: 'allstations',
          component: ChargingStationsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: {
            isOperatorView: true,
            roles: ['Operator'],
            showAll: true
          },
          children: [
            {
              path: '',
              redirectTo: 'summary',
              pathMatch: 'full',
            },
            {
              path: 'groups',
              component: GroupsComponent,
              children: [
                {
                  path: 'edit/:key',
                  component: EditGroupDialogComponent,
                },
                {
                  path: 'delete/:key',
                  component: DeleteGroupDialogComponent
                }
              ]
            },
            {
              path: 'summary',
              component: ChargingStationsTableComponent,
              data: {
                isOperatorView: true,
                roles: ['Operator'],
                showAll: true
              },
              children: [
                {
                  path: 'create',
                  component: CreateChargingStationDialogComponent,
                  data: {
                    isOperatorView: true,
                    roles: ['Operator'],
                    showAll: true
                  }
                },
                {
                  path: 'assistent',
                  component: CreateChargingStationAssistentDialogComponent,
                  data: {
                    isOperatorView: true,
                    roles: ['Operator'],
                    showAll: true
                  }
                },
                //{
                //  path: 'model',
                //  component: ModelTableComponent
                //},
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent,
                  children: [
                    {
                      path: 'delete',
                      component: DeleteChargingStationDialogComponent
                    },
                  ]
                },
                {
                  path: 'delete/:key',
                  component: DeleteChargingStationDialogComponent
                },

                {
                  path: 'restart/:key',
                  component: RestartChargingStationDialogComponent
                },
                {
                  path: 'update',
                  component: UpdateChargingStationDialogComponent
                },
                {
                  path: 'manufacturer',
                  component: ManufacturerTableComponent
                },
                {
                  path: 'statusnotifications',
                  component: StatusNotificationsTableComponent
                }
              ]
            },
          ],
        }, {
          path: 'chargingstations', component: ChargingStationsComponent,
          canActivate: [AuthGuard, RoleGuard],
          data: { roles: ['Customer', 'User', 'Operator'] },
          children: [
            {
              path: '',
              redirectTo: 'summary',
              pathMatch: 'full'
            },
            {
              path: 'summary',
              component: ChargingStationsTableComponent,
              children: [
                {
                  path: 'create',
                  component: CreateChargingStationDialogComponent
                },
                {
                  path: 'edit/:key',
                  component: DetailsChargingStationDialogComponent,
                  children: [
                    {
                      path: 'delete',
                      component: DeleteChargingStationDialogComponent
                    },
                  ]
                },

                {
                  path: 'delete/:key',
                  component: DeleteChargingStationDialogComponent
                }
              ]
            },
            {
              path: 'groups',
              component: GroupsComponent,
              children: [
                {
                  path: 'edit/:key',
                  component: EditGroupDialogComponent,
                },
                {
                  path: 'delete/:key',
                  component: DeleteGroupDialogComponent
                }
              ]
            },
          ]
        },
      ]
    )
  ],
  providers: [
  ],
})
export class ChargingStationsModule { }
